import styles from './MachineStatusOption.module.scss';

export const getMachineStatus = machine => {
  if (!machine?.isOnline) {
    return { key: 'offline', label: 'Offline' };
  }
  if (machine.inOperation) {
    return { key: 'active', label: 'In operation' };
  }
  return { key: 'idle', label: 'Online · Idle' };
};

function MachineStatusOption({ machine, compact = false }) {
  const status = getMachineStatus(machine);

  return (
    <div
      className={`${styles.option} ${compact ? styles.compact : ''}`}
      aria-label={`${machine.nickname}, ${machine.serialNumber}, ${status.label}`}
    >
      <span className={`${styles.statusDot} ${styles[status.key]}`} aria-hidden="true" />
      <span className={styles.identity}>
        <strong>
          {compact ? `${machine.nickname} · ${machine.serialNumber}` : machine.nickname}
        </strong>
        {!compact && (
          <span className={styles.subline}>
            <small className={styles.serial}>{machine.serialNumber}</small>
            {machine.companyName && <small className={styles.company}>{machine.companyName}</small>}
          </span>
        )}
      </span>
    </div>
  );
}

export default MachineStatusOption;
